import { getV1CompaniesCompanyIdSettlementsEmails } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import { SettlementEmailDraft } from '~hooks/useSettlements/models';
import useEmailDraftsQuery from '~queries/useEmailDraftsQuery';

export default function useSettlementEmailDraftsQuery(
  companyId: string,
  settlementIds: string[],
) {
  return useEmailDraftsQuery({
    enabled: Boolean(companyId) && settlementIds.length > 0,
    errorMessage: t('error_messages.settlements.failed_to_fetch_email_drafts'),
    fetchDrafts: async (signal) => {
      const response = await getV1CompaniesCompanyIdSettlementsEmails({
        path: { 'company-id': companyId },
        query: { settlement_ids: settlementIds },
        signal,
      });

      return { drafts: response.data.data.emails.map(SettlementEmailDraft.parse) };
    },
    queryKey: ['settlementEmailDrafts', companyId, settlementIds],
  });
}
